import { render, staticRenderFns } from "./DuplicateReviewDecisionPanel.vue?vue&type=template&id=079faff6&scoped=true"
import script from "./DuplicateReviewDecisionPanel.vue?vue&type=script&lang=js"
export * from "./DuplicateReviewDecisionPanel.vue?vue&type=script&lang=js"
import style0 from "./DuplicateReviewDecisionPanel.vue?vue&type=style&index=0&id=079faff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079faff6",
  null
  
)

export default component.exports